/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { Activation } from 'api';
import { COUNTDOWN_INTERVAL, INITIAL_COUNTDOWN } from 'common/constants/login';
import {
  ACCOUNT_ACTIVATED,
  ACCOUNT_ACTIVATION_RESEND,
  ERROR_OCCURRED,
  REDIRECT_TO,
} from 'common/constants/messages/validations';
import { MessageBox } from 'components';
import { MessageBoxType } from 'components/MessageBox/MessageBox.props';
import { useActivateUser } from 'services/hooks/auth';
import { ActivateAccountProps } from './ActivateAccount.props';
import { Actions, LoadingContainer, Root } from './ActivateAccount.styles';

const ActivateAccount = ({ history }: ActivateAccountProps) => {
  const { uid, token } = useParams<Activation>();
  const navigate = useNavigate();
  const activateUser = useActivateUser();

  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState<string>('');
  const [severity, setSeverity] = useState<MessageBoxType | undefined>(undefined);
  const [firstLoad, setFirstLoad] = useState(true);
  const [countDown, setCountDown] = useState(INITIAL_COUNTDOWN);

  useEffect(() => {
    if (firstLoad) {
      const activate = async () => {
        const [data, error] = await activateUser(uid, token);

        if (error) {
          setSeverity('error');
          setMessage(error?.response?.body?.token ? ACCOUNT_ACTIVATION_RESEND : ERROR_OCCURRED);
        } else {
          setSeverity('success');
          setMessage(ACCOUNT_ACTIVATED);
          navigate(`/${data.password_reset_url}?afterActivation=true`);
        }
        setIsLoading(false);
      };
      activate();
      setFirstLoad(false);
    }
  }, [activateUser, uid, token, firstLoad]);

  const goToSignIn = () => navigate('/');

  useEffect(() => {
    const interval = setInterval(() => {
      if (countDown > 0) {
        setCountDown(prevCountDown => prevCountDown - 1);
      } else {
        clearInterval(interval);
        goToSignIn();
      }
    }, COUNTDOWN_INTERVAL);
    return () => clearInterval(interval);
  }, [countDown]);

  if (isLoading) {
    // Return a loading message as JSX element
    return <LoadingContainer>Loading...</LoadingContainer>;
  }

  return (
    <Root>
      <MessageBox title={message} tagline={REDIRECT_TO('Sign In page', countDown)} type={severity} />
      <Actions>
        <Button variant="text" color="primary" onClick={goToSignIn} endIcon={<ArrowForwardIcon />}>
          Sign In
        </Button>
      </Actions>
    </Root>
  );
};

ActivateAccount.propTypes = {
  history: PropTypes.func,
};

export default ActivateAccount;
